type NewValue<T> = [keyof T, any];

export const getDifferences = <T extends Record<string, any>>(prev: T, next: any): NewValue<T>[] =>
  Object.entries(prev).reduce((acc, [key, prevValue]) => {
    const nextValue = next[key];
    // Special case to deal with https://github.com/react-hook-form/react-hook-form/issues/656
    if (nextValue !== prevValue && !(nextValue === null && prevValue === '')) {
      acc.push([key, nextValue]);
    }
    return acc;
  }, [] as NewValue<T>[]);
